exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-d9ccb0aa],\n.fade-leave-active[data-v-d9ccb0aa] {\n  transition: opacity 0.5s ease;\n}\n.fade-enter[data-v-d9ccb0aa], .fade-leave-to[data-v-d9ccb0aa] {\n  opacity: 0;\n}\n", ""]);

// exports
